import React, { useState } from 'react'
import "./Resume.css"
import SectionHeading from "./../../utilities/SectionHeading"

export default function Resume(props) {
    const [selectedBulletIndex, setSelectedBulletIndex] = useState(0);
    const [carousalOffsetStyle, setCarousalOffsetStyle] = useState({});

    const ResumeHeading = (props) => {

        return (
            <div className="resume-heading">
                <div className="resume-main-heading">
                    <div className="heading-bullet">

                        <span className='education-heading' style={{color:props.color}} >{props.heading}</span>
                        {props.fromDate && props.toDate ? (
                            <div className="heading-date">
                                {props.fromDate + "-" + props.toDate}
                            </div>
                        ) : (
                            <div></div>
                        )}

                    </div>
                    <div className="resume-sub-Heading">
                        <span>{props.subHeading}</span>
                    </div>
                    <div className="resume-heading-description">
                        <span>{props.description}</span>
                    </div>
                </div>
            </div>
        )
    };

    const resumeBullets = [
        { label: "Education", logo: "education.png" },
        { label: "Programming Skills", logo: "coding.png" },
        { label: "Interests", logo: "bot.png" },
        { label: "Achievements", logo: "trophy.png" },
    ];

    const programmingSkills = [
        // { skill: "C", percentage: 60, logoSrc:"c.png", height:"18px" },
        { skill: "C++", percentage: 90, logoSrc:"c++.png", height:"18px"},
        { skill: "Java", percentage: 60, logoSrc:"java.png", height:"18px"},
        { skill: "Python", percentage: 55, logoSrc:"python.png", height:"18px" },
        { skill: "JavaScript", percentage: 80, logoSrc:"js.jpg", height:"16px" },
        { skill: "HTML/CSS", percentage: 80, logoSrc:"html-css.png", height:"18px" },
        { skill: "NodeJS", percentage: 75, logoSrc:"nodejs.png", height:"20px" },
        { skill: "ReactJS", percentage: 85, logoSrc:"reactjs.jpg", height:"20px" },
        { skill: "NextJS", percentage: 90, logoSrc:"nextjs.png", height:"20px" },
        // { skill: "ExpressJS", percentage: 80, logoSrc:"ex.png", height:"16px" },
        { skill: "MongoDB", percentage: 80, logoSrc:"mongodb.png", height:"18px" },
        { skill: "Firebase", percentage: 80, logoSrc:"firebase.png", height:"18px" },
    ];

    const resumeDetails = [
        <div className="resume-screen-container" key="education">
            <ResumeHeading heading={"Jadavpur University, Kolkata"} subHeading="BTech in Information Technology" fromDate={"2020"} toDate={2024} color="rgb(211, 9, 9)" />

            <ResumeHeading heading={"Pannalal Institution, Kalyani"} subHeading="Higher Secondary Education" fromDate={"2018"} toDate={2020} color="rgb(211, 9, 9)"/>
        </div>,

        <div className="resume-screen-container programming-skills-container" key="programming_skill">
            {programmingSkills.map((skill, i) => (
                <div className="skill-parent" key={i}>

                    <div className="skill-box">
                        <img src={require(`./../../static/${skill.logoSrc}`)} style={{height: skill.height}} alt="" />
                        <span>{skill.skill}</span>
                        <div className="skill-percentage">
                            <div className='active-percentage' style={{ width: skill.percentage + "%" }}>
                                
                            </div>
                        </div>
                    </div>

                </div>
            ))}
        </div>,

        <div className="resume-screen-container-interests" key="interests">

            <ResumeHeading heading="Drawing" description="&emsp; Apart from being a tech enthusiast I also love to draw. I did diploma in Fine Arts from Sarbabharatiya Charu-O-karukala Niket. I love to draw portraits. I spare my leisure times drawing sketches of my favourite heroes." color="rgb(211, 9, 9)"/>

            {/* <ResumeHeading heading="Teaching" description="I love teaching because at the end of every lesson not only have I imparted some of my knowledge but I have also learnt something myself." color="rgb(211, 9, 9)" /> */}

            <ResumeHeading heading="Music" description="&emsp; Listening to soothing music is something I can never compromise with, skimming through Spotify's pop songs..." color="rgb(211, 9, 9)"/>

            <ResumeHeading heading="Gaming" description="&emsp; I like to challenge my reflexes a lot while competing in football games pushing the rank and having interactive gaming sessions excites me the most." color="rgb(211, 9, 9)"/>

        </div>,

        <div className="resume-screen-container-extraCurricular" key="extracurricularActivities">
            <ResumeHeading heading="Coding Conquest 2022" description=" &emsp; Winner in Coding Conquest 2022 hackathon organised by Code Conquerors Club (CCC),
Sushant University, Gurugram" color="rgb(5, 156, 73)"/>

            <ResumeHeading heading="Error 404 Hackathon" description="&emsp; 2nd Runner Up among 800+ participants in Error 404 Hackathon organised by Micro
Organization" color="rgb(5, 156, 73)"/>


        </div>
    ];

    const handleCarousal = (index) => {
        let offsetHeight = 360;
        let newCarousalOffset = {
            style: { transform: "translateY(" + index * offsetHeight * -1 + "px)" }
        };
        setCarousalOffsetStyle(newCarousalOffset);
        setSelectedBulletIndex(index);
    };

    const getBullets = () => {

        return resumeBullets.map((bullet, index) => (
            <div onClick={() => handleCarousal(index)} className={index === selectedBulletIndex ? "bullet selected-bullet" : "bullet"} key={index} >

                <img className="bullet-logo" src={require(`./../../static/${bullet.logo}`)} alt="B" />
                <span className="bullet-label">{bullet.label}</span>

            </div>
        ));
    };

    const getResumeScreen = () => {
        return (
            <div className="resume-details-carousal" style={carousalOffsetStyle.style} >
                {resumeDetails.map((ResumeDetail) => ResumeDetail)}
            </div>
        );
    };

    return (
        <div>
            <section id="Resume" data-aos="fade-in">
                <SectionHeading heading="Resume" description="My Formal Bio Details" />

                <div className="resume-container screen-container" id={props.id || ""} data-aos="fade-right">
                    <div className="resume-content">

                        <div className="resume-card">
                            <div className="resume-bullets">
                                <div className="bullet-container">
                                    <div className="bullet-icons"></div>
                                    <div className="bullets">{getBullets()}</div>
                                </div>
                            </div>
                            <div className="resume-bullet-details"> {getResumeScreen()} </div>
                        </div>

                    </div>
                </div>
            </section>
        </div>
    )
}